var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navButton"},[_c('button',{on:{"click":_vm.navigateToMiniProgramPage}},[_vm._v("前往小程序支付")])])}
var staticRenderFns = []

export { render, staticRenderFns }